<div class="modal-header d-flex align-items-center" [ngClass]="{'is-ach': forCheckingAccounts}">
  <h2 class="c-heading-36 font-bold w-100 col-11 mb-0" id="modal-basic-title">{{forCheckingAccounts ? 'Add New Checking Account' : 'Add new card details' }}</h2>
  <button type="button" class="close-banner col-1" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover" (click)="activeModal.dismiss('Cross click')"></i>
  </button>
</div>
<div class="modal-body">
  <iframe
    title=""
    #iframe
    id="valid-for-data"
    [height]="iframeHeight()"
    [src]="urlSafe"
    name="valid-for-data"
    *ngIf="iframeLoad"
  ></iframe>
</div>
<div class="modal-footer px-4 pt-0">
  <img class="mb-4 mt-0 modal-tip-image" (click)="open()" src="{{IMAGE_SRC}}">
  <div class="add-card-checkbox-wrapper">
      <input
        id="makeDefault"
        type="checkbox"
        class="promoted-input-checkbox"
        [(ngModel)]="makeDefaultMethod"
        [disabled]="this.isProfilePage() ? this.forceDefaultPayment() : false"
      />
      <label for="makeDefault">
        @if (isProfilePage()) {
          {{'makeAPayment.makeDefaultPaymentMethod' | cxTranslate }}
        } @else {
          {{'makeAPayment.makeDefaultPaymentMethodAndSave' | cxTranslate }}
        }
      </label>
    </div>
  <div class="d-flex mt-2">
    <button class="c-button c-button--secondary col-md-6 pr-2 py-4" (click)="activeModal.close('Close click')">Cancel</button>
    &nbsp; &nbsp;
    <button class="c-button c-button--primary col-md-6 pl-2 py-4" (click)="onSubmitIFrame()">
      {{ forCheckingAccounts ? 'Add new checking account' : 'Add new card' }}
    </button>
  </div>
</div>
